import { SubscriptionRequest } from '../model/subscription-request';
import { BillingAddress } from '../model/billing-address';
import { Product } from '../../product/model/product';

export class ValidateCoupon {
  static readonly type = '[Subscription] Validate Coupon';
  constructor(
    public couponCode: string,
    public apiName: string
  ) {}
}

export class ClearCoupon {
  static readonly type = '[Subscription] Clear Coupon';
}

export class SetSelectedProduct {
  static readonly type = '[Subscription] Set Selected Product';
  constructor(public selectedProduct: Product) {}
}

export class PreviewSubscription {
  static readonly type = '[Subscription] Preview Subscription';
  constructor(
    public productName: string,
    public couponCode: string | null = null,
    public referralCode: string | null = null
  ) {}
}

export class GenerateChargifyToken {
  static readonly type = '[Subscription] Generate Chargify Token';
  constructor(
    public formElement: HTMLFormElement,
    public billingAddress?: BillingAddress
  ) {}
}

export class CreateSubscription {
  static readonly type = '[Subscription] Create Subscription';
  constructor(public request: SubscriptionRequest) {}
}

export class ClearSubscriptionData {
  static readonly type = '[Subscription] Clear Data';
}
